import { InjectionToken } from '@angular/core';

export interface EservicesConfiguration {
  maxStatements: number;
  maxConfirms: number;
  maxTaxes: number;
  maxPortfolioReports: number;
  batchProcessEnabled: boolean;
  maxPicStatements: number;
  maxCorporateActions: number;
  corporateActionsPageSize: number;
}

export const ESERVICES_CONFIGURATION = new InjectionToken<EservicesConfiguration>('eservicesConfiguration');
